
<div class="subscribe-container mt-5" v-if="formLoaded">
    <h3 v-html="stepTitles[step]"></h3>
    <form class="fields-container">
        <div v-if="step === 0">
            <div v-for="field in fields.slice(0, 2)" class="my-3" v-if="!field.hidden" :key="field.slug">
                <Input
                  :field="field"
                  v-model="formValues[field.slug]"
                  :show_label="false"
                />
                <span class="error-label d-flex mt-1" v-html="errors[field.slug]"></span>
            </div>
        </div>
        <div v-else-if="step === 1">
            <div v-for="field in fields.slice(2)" class="my-3" v-if="!field.hidden" :key="field.slug">
                <Input
                  :field="field"
                  v-model="formValues[field.slug]"
                  :show_label="false"
                />
                <span class="error-label d-flex mt-1" v-html="errors[field.slug]"></span>
            </div>
        </div>
    </form>
    <div v-if="loading" class="spinner-border text-light spinner-border-sm" role="status"></div>
    <button v-if="!loading && step !== 2" class="btn btn-primary mx-auto w-100" @click="changeStep()">{{ step === 1 ? 'Enviar': 'Siguiente'}}</button>
</div>
